module.exports = __webpack_public_path__ + "img/serve7.b7a5978c.png";